import { NavigateFunction } from "react-router-dom";
import { Action } from "redux";

import { Dictionary } from "./utils.types";

export interface ICanvasDimension {
  width: string;
  height: string;
}

export enum EInterviewerStatus {
  UPCOMING = "UPCOMING",
  YET_TO_START = "YET TO START",
  ONGOING = "ONGOING",
  FEEDBACK_PENDING = "FEEDBACK PENDING",
  FINISHED = "FINISHED",
  CANCELLED = "CANCELLED",
  ON_HOLD = "ON_HOLD",
  SELECTED = "SELECTED",
  REJECTED = "REJECTED",
}

export enum ERatingType {
  RATING = "rating",
  DESCRIPTION = "description",
  HYBRID = "hybrid",
}

export interface TEvaluationCriteria {
  name: string;
  type: ERatingType;
  rating?: number;
  description?: string;
  category: string;
  sub_types: ("rating" | "description")[];
  order: number;
}

export interface IJobRole {
  role: string;
  title: string;
  description: string;
  slug: string;
  other_role: string;
  settings: IJobRoleSettings;
}

export interface IJobRoleSettings {
  support: ISupport;
  reporting: IReporting;
}

export interface IReporting {
  administrators: string[];
  redirection_url: string;
  custom_confirmation: ICustomConfirmation;
}

export interface ICustomConfirmation {
  note: string;
  enabled: boolean;
}

export interface ISupport {
  email: string;
  phone: string;
}

export interface IRealTimeAlertSettings {
  consecutive_detection_enabled: boolean;
  consecutive_detection_count: number;
  detection_time_in_seconds: number;
}

export interface ISettings {
  platform_feedback_enabled: boolean;
  recording_enabled: boolean;
  score_card_enabled: boolean;
  is_cam_toggleable: boolean;
  is_mic_toggleable: boolean;
  candidate_real_time_alert_enabled: boolean;
  interviewer_real_time_alert_enabled: boolean;
  candidate_real_time_alert_settings: IRealTimeAlertSettings;
  interviewer_real_time_alert_settings: IRealTimeAlertSettings;
}

export enum EInterviewType {
  AD_HOC = "AD_HOC",
  SCHEDULE = "SCHEDULE",
}

export interface IInterviewerSettings {
  redirection_url: string | null;
}

export interface IInterviewDetails {
  id: number;
  slug: string;
  status: EInterviewerStatus;
  interview_type: EInterviewType;
  start_time: string;
  started_at: string;
  end_time: string;
  expiry: string;
  job_role: IJobRole;
  access_code: string;
  accessCode: string;
  settings: ISettings;
  interviewer: IInterviewerSettings;
}

export interface IGetInterviewDetailsAction extends Action {
  payload: {
    interviewSlug: string;
  };
}

export interface IEvaluationRating {
  name?: string;
  type?: ERatingType;
  category?: string;
  value?: number;
  description?: string;
}

export interface IUpdateRatingArgs extends Action {
  payload: {
    interviewSlug: string;
    feedbackSlug: string;
    criteria?: string;
    name?: string;
    ratingType?: ERatingType;
    ratingSubTypes: ("rating" | "description")[];
    category: string;
    ratingValue?: number;
    description?: string;
    status?: string;
    order: number;
    source: string;
  };
}

export interface IUpdateInterviewerAction extends Action {
  payload: {
    interviewerSlug: string;
    navigate: NavigateFunction;
    interviewSlug: string;
    feedbackSlug: string | null;
    id?: number;
    slug?: string;
    status: EInterviewerStatus | null;
    evaluationRatings: Dictionary<TEvaluationCriteria>;
    source: string;
  };
}

export interface IInterviewType extends Action {
  payload: IInterviewDetails;
  type: string;
}

export interface IGetInterviewMetaAction extends Action {
  payload: {
    accessCode: string;
  };
}
